import { SET_ACCOUNTING_PAGE_COUNT, SET_CARD_REQUESTS_COUNT, SET_PERSONAL_REIMBURSABLE_EXPENSES_COUNT, SET_READY_TO_PAY_BILLS_COUNT, SET_RECEIPTS_COUNT, SET_RECURRING_SPEND_SUGGESTIONS_COUNT, SET_REIMBURSABLE_EXPENSES_COUNT, SET_SIDEBAR_PERSONAL_TRANSACTIONS_COUNT, SET_SIDEBAR_TRANSACTIONS_COUNT } from '../actions';
export const defaultState = {
    transactionsCount: null,
    reimbursableExpensesCount: null,
    cardRequestsCount: null,
    readyToPayBillsCount: null,
    personalTransactionsCount: null,
    personalReimbursableExpensesCount: null,
    receiptsCount: null,
    recurringSpendSuggestionsCount: null,
    accountingPageCount: null
};
export const sidebarCountersReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_SIDEBAR_TRANSACTIONS_COUNT:
            return Object.assign(Object.assign({}, state), { transactionsCount: action.payload });
        case SET_CARD_REQUESTS_COUNT:
            return Object.assign(Object.assign({}, state), { cardRequestsCount: action.payload });
        case SET_REIMBURSABLE_EXPENSES_COUNT:
            return Object.assign(Object.assign({}, state), { reimbursableExpensesCount: action.payload });
        case SET_PERSONAL_REIMBURSABLE_EXPENSES_COUNT:
            return Object.assign(Object.assign({}, state), { personalReimbursableExpensesCount: action.payload });
        case SET_SIDEBAR_PERSONAL_TRANSACTIONS_COUNT:
            return Object.assign(Object.assign({}, state), { personalTransactionsCount: action.payload });
        case SET_RECEIPTS_COUNT:
            return Object.assign(Object.assign({}, state), { receiptsCount: action.payload });
        case SET_READY_TO_PAY_BILLS_COUNT:
            return Object.assign(Object.assign({}, state), { readyToPayBillsCount: action.payload });
        case SET_RECURRING_SPEND_SUGGESTIONS_COUNT:
            return Object.assign(Object.assign({}, state), { recurringSpendSuggestionsCount: action.payload });
        case SET_ACCOUNTING_PAGE_COUNT:
            return Object.assign(Object.assign({}, state), { accountingPageCount: action.payload });
        default:
            return state;
    }
};
